import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgBriefcaseIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="briefcase_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M43 10h-2V5H23v5h-2V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v6zM39 46v3a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1v-3H5v11a4 4 0 0 0 4 4h46a4 4 0 0 0 4-4V46H39z"
      />
      <path d="M59 12H5a4 4 0 0 0-4 4v27a1 1 0 0 0 1 1h23v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3h23a1 1 0 0 0 1-1V16a4 4 0 0 0-4-4z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgBriefcaseStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgBriefcaseIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const BriefcaseIcon: any = SvgBriefcaseStyle;
export default BriefcaseIcon;
